export enum ProgressItemStatus {
    COMPLETE = 'complete',
    INCOMPLETE = 'incomplete'
}
